import { gql } from 'apollo-angular';
import { buildConnectionQuery } from "../../../helpers.class";

export const nodeFragment = `
  id
  name
`;

export const phoneTypeQuery = gql`${buildConnectionQuery("PhoneType", "phoneTypeConnection", nodeFragment)}`;
